<template>
  <v-card
    id="encours"
    fluid
  >
  <v-card-title class="blue darken-3">
          <span class="text-h5 white--text">Journalisation Objets</span>

  </v-card-title>
  

<template>
  <v-data-table
    :headers="headers"
    :items="datas"
    :items-per-page="100"
    class="elevation-1"
  ></v-data-table>
</template>

</v-card>
</template>
<script>
  
  export default {

    data: () =>({

      datas :[],
      headers: [
          {
            text: 'Mission',
            align: 'start',
            sortable: true,
            value: 'MISS',
          },
          { text: 'Og', value: 'NOM_OG' },
          { text: 'Objet', value: 'NOM_OBJET' },
          { text: 'p', value: 'P' },
          { text: 'Poses', value: 'NbPoses' }

        ],
      N_Dernieres : 1,
      Unite:"Minutes",
      Unites:['Semaines','Jours','Heures','Minutes'],
      modes: ['Dernières données', 'Interval de dates','Depuis une date'],
      mode_choisi : 'Dernières données',

      start_time : null,
      start_date :null,

      je_cherche : false,

      end_time : null,
      end_date :null,
      url :"",
      data:{},

    }),
  initialize(){

  },
  created(){
    
  },
  beforeMount(){
     

  },
  mounted(){

    this.get_Objets();
  //  this.load_Target();
/*    this.A_Update_target = setInterval(() => {
      this.get_Target();
      this.load_Target();
    },2000);*/
  },
  methods: {
    get_Objets(){
      

      const othis=this;
        
        othis.url = "";
        othis.url = backend_url + "/journalisationbeta/objects";
        othis.data = {};
        //console.log(othis.url);
        this.axios.get(othis.url,othis.data)
        .then((res) => {
          //console.log(res);
          othis.datas = res.data.table;
        })
        .catch((error) => {
          console.error(error);
          console.log("PB get -> Get_Journalisation_Objes");
        });

    }

  }
}
</script>